import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import MyIcon from "../Common/MyIcon";
import ConfigurationIcon from "../../assets/icons/Icon_Library/application icons/monitoring/configuration-01.svg2";
import {
  useGetImportedSolutionInfoByUuidQuery,
  useResetImportedSolutionInfoByUuidMutation,
  useSetImportedSolutionVariableDefaultsMutation,
} from "../store/slices/settingsSlice";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import ProjectStartForm from "../Builder/Components/sidebar/ProjectStartForm";
import { solutionRolesMapping } from "../Library/SelectSolutionProject";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

export default function ConfigurationModal({ uuid }) {
  const info =
    useGetImportedSolutionInfoByUuidQuery({ uuid }, { skip: !uuid }).data || {};

  const [variableDefaults, setVariableDefaults] = useState({});
  const [save] = useSetImportedSolutionVariableDefaultsMutation();
  const [reset] = useResetImportedSolutionInfoByUuidMutation();

  const [isSaving, setIsSaving] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const confirmDialog = useConfirmDialog();
  return (
    <>
      {info.LatestSource?.Solution?.Components?.filter(
        (comp) =>
          comp.Type === "project" &&
          comp.Item.InputArguments?.filter(
            (arg) => arg.IsParameter && !arg.SolutionDoNotConfigure
          ).length > 0
      ).map((comp) => {
        const projectId = info.DeployedComponents?.find(
          (dc) => dc.ItemUuid === comp.ItemUuid
        )?.ProjectID;
        return (
          <div
            className="bg-purple-gradient-darker my-3 rounded w-50"
            title={`${solutionRolesMapping[comp.Role]?.label}: ${
              comp.Item?.Label || comp.ComponentUuid.substring(0, 8)
            }`}
            key={comp.ComponentUuid}
          >
            <div className="p-3">
              <h3>
                Default values for {comp.Item?.Label} [
                {solutionRolesMapping[comp.Role]?.label}]
              </h3>
              <ProjectStartForm
                projectID={projectId}
                showHiddenVariables={true}
                onChange={(varDef) => {
                  setVariableDefaults((prev) => ({
                    ...prev,
                    [comp.ComponentUuid]: varDef,
                  }));
                }}
                hideStartButton
                filterInputArguments={(arg) =>
                  arg.IsParameter && !arg.SolutionDoNotConfigure
                }
                isSolution
                // initialInputArguments={comp.Item.InputArguments?.map((arg) => ({
                //   ...arg,
                //   Label: `${arg.Label}${
                //     arg.Role ? ` (Role: ${arg.Role})` : ""
                //   }`,
                // }))}
                // initialVariableGroups={comp.Item.VariableGroups}
                initialFormData={
                  info.SolutionClientSettings?.VariableDefaults?.[
                    comp.ComponentUuid
                  ]
                }
              />
            </div>
          </div>
        );
      })}
      <div className="d-flex justify-content-end my-3">
        <button
          type="button"
          className="btn btn-colored"
          onClick={async () => {
            setIsSaving(true);
            const res = await save({
              uuid: info.LatestSource.SolutionClientUuid,
              body: variableDefaults,
            });
            setTimeout(() => {
              if ("data" in res) {
                // alert("Variable defaults saved successfully");
                toast.success("Variable defaults saved successfully");
              }
              setIsSaving(false);
            }, 700);
          }}
          disabled={isSaving || isResetting}
        >
          Save Variable Defaults{" "}
          {isSaving ? (
            <FontAwesomeIcon icon={faSpinner} spin className="ms-2" />
          ) : (
            ""
          )}
        </button>
        <button
          type="button"
          className="btn btn-colored"
          onClick={async () => {
            if (
              (await confirmDialog(
                "Reset solution",
                `Are you sure you want to reset this solution?`
              )) === false
            ) {
              return;
            }
            setIsResetting(true);
            const res = await reset({
              uuid: info.LatestSource.SolutionClientUuid,
            });
            setTimeout(() => {
              if ("data" in res) {
                // alert("Solution reset successfully");
                toast.success("Solution reset successfully");
              }
              setIsResetting(false);
            }, 700);
          }}
          disabled={isSaving || isResetting}
        >
          Reset Solution{" "}
          {isResetting ? (
            <FontAwesomeIcon icon={faSpinner} spin className="ms-2" />
          ) : (
            ""
          )}
        </button>
      </div>
      <JsonCollapse json={variableDefaults} />
    </>
  );
}
